<div class="bottom-20"></div>
<div class="content">
    <div class="container">
        <div class="row">
            <div *ngIf="correction" class="col-16">
                <label>Please explain what needs to be corrected</label>
                <textarea rows="3" cols="60" text="txtCorrection" [(ngModel)]="eappUpdateStatusModel.Reason"></textarea>
            </div>
            <div *ngIf="!correction" class="col-16">
                <label>Are you sure you want to cancel?</label>
            </div>
        </div>

        <div class="row">
            <div class="col-24">
                <button (click)="continueClick()" class="button primary">Continue</button>
                <button (click)="btnBack()" class="button cancel">Go Back</button>
            </div>
        </div>
    </div>
</div>